import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconChatbot } from '@redteclab/icons'

import { Button } from 'base-ui'

const CONTACT_PAGE_CHAT_BOT_LAUNCH_DATA = JSON.stringify({
  intent: 'general_welcome',
  theme: 'default',
})

export const ContactPageChatBotLabel: FC = () => {
  return (
    <Button
      className="w-full"
      data-launch-chat={CONTACT_PAGE_CHAT_BOT_LAUNCH_DATA}
      endIcon={<IconArrowRight className="fill-dark-brand" />}
      id="contact.page.chatbot.label"
      key="contact.page.chatbot.label"
      size="large"
      startIcon={<IconChatbot className="fill-dark-brand" />}
      variant="text"
    >
      <span className="grow text-start">
        <FormattedMessage id="contact.faqSection.chatbotCard.title" />
      </span>
    </Button>
  )
}
